module.exports = __webpack_public_path__ + "img/car-E.b4caa5fc.jpg";